// extracted by mini-css-extract-plugin
export var section = "featuresMobile-module--section--oyYVM";
export var head = "featuresMobile-module--head--m6gYr";
export var subtitle = "featuresMobile-module--subtitle--3DxuB";
export var links = "featuresMobile-module--links--szGfX";
export var links_item = "featuresMobile-module--links_item--2Imv1";